import { api } from '@/core/api'
import type { User } from '../models'

export const fetchCurrentUser = () => {
  return api.Get<User>('/v1/api/users/me/')
}
